import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import CtaSection from "@/components/cta/CtaSection.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutSidebarCta',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CtaSection, { id: "cta" }))
}
}

})